import { Component, ElementRef, ViewChild } from "@angular/core";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import Swal from "sweetalert2";
import {
  Mantenimiento,
  MantenimientoService,
} from "../../../../shared/services/mantenimientos.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { TanqueoService } from "../../../../shared/services/tanqueo.service";
import jsPDF from "jspdf";
import { AdministracionService } from "src/app/shared/services/administracion.services";
import { Administracion } from "src/app/shared/model/administracion.model";
import { gpcGoogleService } from "src/app/shared/services/gpcGoogle.service";

export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}

@Component({
  selector: "app-consultar-combustible",
  templateUrl: "./consultar-combustible.component.html",
  styleUrls: ["./consultar-combustible.component.scss"],
})
export class ConsultarCombustibleComponent {
  @ViewChild("inputSistema") inputSistema!: ElementRef;
  @ViewChild("inputParte") inputParte!: ElementRef;
  @ViewChild("inputTipo") inputTipo!: ElementRef;

  vehiculos: any[] = [];
  resultadosPlanillas: Mantenimiento[] = [];
  filteredTableItems!: Mantenimiento[];
  mostrarTabla: boolean = false;
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  public searchText: string = ""; // Texto de búsqueda
  editMode!: boolean;
  modalServicioRef: any;
  validate!: boolean;
  valorFormateado!: string;
  formTanqueo: FormGroup;
  resultadosTanqueos!: any[];
  filteredTanqueos!: any[];
  minFechaFinal: string = "";
  public activity: any[] = []; // Inicialmente vacío
  hoy: string = "";
  public show: boolean = false;
  pageSize = 5;
  currentPage = 1;
  totalPages: number = 1;
  paginatedActivity: any[] = [];
  itemsPerPage: number = 5;
  mensajeBusqueda: string = "";
  administraciones: Administracion[] = []
  altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;
  constructor(
    private vehiclesService: VehiclesService,
    private tanqueosService: TanqueoService,
    private fb: FormBuilder,
    private administracionesServices: AdministracionService,
    private gpcGoogle: gpcGoogleService,
  ) {}

  ngOnInit() {
    this.cargarVehiculos();
this.cargarDataAdmin();
    this.formTanqueo = this.fb.group({
      fecha: [null, [Validators.required]],
      placa: [null, [Validators.required, noEspaciosEnBlanco()]],
      tipo: [null, [Validators.required]],
      taller: [null, [Validators.required]],
      servicio: [null, [Validators.required]],
      accion: [null, [Validators.required]],
      factura: [null, [Validators.required, noEspaciosEnBlanco()]],
      vrpagos: [null, [Validators.required]],
      forma: [null, [Validators.required]],
      conductor: [null, [Validators.required]],
      observacion: [null],
      fechaFinal: [null],
    });

    const hoyDate = new Date();
    this.hoy = this.formatoFecha(hoyDate);
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacasAll().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }
  buscarTanqueos(): void {
    const placa = this.formTanqueo.value.placa?.trim();
    let fecha = this.formTanqueo.value.fecha?.trim();
    let fechaFinal = this.formTanqueo.value.fechaFinal?.trim();

    // Aplica lógica de formato de fecha
    if (fecha) {
      // Si la fecha viene como 'YYYY-MM-DD', ajusta a 'YYYY-MM-DD 00:00:00'
      fecha = fecha.length === 10 ? `${fecha} 00:00:00` : fecha;
    }
    if (fechaFinal) {
      // Si la fecha viene como 'YYYY-MM-DD', ajusta a 'YYYY-MM-DD 23:59:59'
      fechaFinal = fechaFinal.length === 10 ? `${fechaFinal} 23:59:59` : fechaFinal;
    }

    const camposObligatorios = [
      { campo: "placa", mensaje: "Por favor, selecciona una placa" },
      { campo: "fecha", mensaje: "Por favor, selecciona la fecha inicial" },
      { campo: "fechaFinal", mensaje: "Por favor, selecciona la fecha final" },
    ];

    for (const { campo, mensaje } of camposObligatorios) {
      if (!this.formTanqueo.get(campo)?.value) {
        this.mostrarAlerta("Campo requerido", mensaje, "info");
        return;
      }
    }

    if (!placa && !fecha && !fechaFinal) {
      this.resultadosTanqueos = [];
      this.filteredTanqueos = [];
      this.activity = [];
      this.paginatedActivity = [];
      this.mensajeBusqueda =
        "Debes proporcionar al menos un filtro para buscar.";
      this.mostrarTabla = false;
      return;
    }

    this.tanqueosService
      .buscarTanqueosPorFiltros(placa, fecha, fechaFinal)
      .subscribe({
        next: (resp) => {
          this.resultadosTanqueos = resp.tanqueos;
          this.filteredTanqueos = resp.tanqueos;
          this.mensajeBusqueda =
            resp.mensaje || "No hay datos de tanqueos para mostrar.";
          this.mostrarTabla = true;

          if (!resp.tanqueos || resp.tanqueos.length === 0) {
            this.activity = [];
            this.paginatedActivity = [];
            this.totalPages = 1;
            this.currentPage = 1;
            this.mensajeBusqueda =
              resp.mensaje || "No se encontraron registros.";
            this.mostrarTabla = true;
            return;
          }

          this.activity = resp.tanqueos.map((tanqueo: any) => {
            let color = "primary";
            if (tanqueo.total > 100000 && tanqueo.total <= 300000) {
              color = "warning";
            } else if (tanqueo.total > 300000) {
              color = "secondary";
            }

            const [year, month, day] = tanqueo.fecha.split("-");
          const fechaSinZona = new Date(Number(year), Number(month) - 1, Number(day));
            return {
              date: fechaSinZona.toLocaleDateString("es-CO", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              },
            ),
              
              title: `Galones: ${tanqueo.galones}`,
              dace: `Total: $${tanqueo.total.toLocaleString("es-CO")}`,
              time: new Date(tanqueo.fecha).toLocaleTimeString("es-CO"),
              primaryDotColor: color,
            };
          });

          this.currentPage = 1;
          this.paginateActivity();
        },
        error: (err) => {
          console.error("❌ Error al buscar tanqueos:", err);
          this.resultadosTanqueos = [];
          this.filteredTanqueos = [];
          this.activity = [];
          this.paginatedActivity = [];
          this.totalPages = 1;
          this.currentPage = 1;
          this.mensajeBusqueda = "Ocurrió un error al buscar tanqueos.";
          this.mostrarTabla = true; // 🔥 Asegúrate de esto también
        },
      });
  }

  paginateActivity(): void {
    if (!this.activity || this.activity.length === 0) {
      this.paginatedActivity = [];
      this.totalPages = 1;
      return;
    }

    this.totalPages = Math.ceil(this.activity.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedActivity = this.activity.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginateActivity();
    }
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  actualizarMinFechaFinal(): void {
    const fechaInicialStr = this.formTanqueo.get("fecha")?.value;

    if (fechaInicialStr) {
      const fechaInicial = new Date(fechaInicialStr);
      const fechaFinal = new Date(fechaInicial);
      fechaFinal.setDate(fechaFinal.getDate() + 1); // suma 1 día

      // Formato local: yyyy-MM-dd
      this.minFechaFinal = [
        fechaFinal.getFullYear(),
        String(fechaFinal.getMonth() + 1).padStart(2, "0"),
        String(fechaFinal.getDate()).padStart(2, "0"),
      ].join("-");

      const fechaFinalControl = this.formTanqueo.get("fechaFinal");
      if (
        fechaFinalControl?.value &&
        fechaFinalControl.value < this.minFechaFinal
      ) {
        fechaFinalControl.setValue("");
      }
    }
  }

  formatoFecha(fecha: Date): string {
    const fechaColombia = fecha.toLocaleDateString("es-CO", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const [dia, mes, anio] = fechaColombia.split("/");
    return `${anio}-${mes}-${dia}`; // Formato YYYY-MM-DD
  }

  // ✅ Resta días exactos a una fecha
  restarDias(fecha: Date, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - dias);
    return nuevaFecha;
  }
  // ✅ Selecciona el rango dinámicamente según el botón presionado
  seleccionarRango(
    rango: "dia" | "semana" | "mes" | "trimestre" | "semestre" | "anio"
  ): void {
    const hoy = new Date(); // 📅 Fecha actual
    let diasARestar = 0;

    switch (rango) {
      case "dia":
        diasARestar = 1;
        break;
      case "semana":
        diasARestar = 7;
        break;
      case "mes":
        diasARestar = 30;
        break;
      case "trimestre":
        diasARestar = 90;
        break;
      case "semestre":
        diasARestar = 180;
        break;
      case "anio":
        diasARestar = 365;
        break;
    }

    const fechaInicio = this.restarDias(hoy, diasARestar);
    const fechaInicioStr = this.formatoFecha(fechaInicio);
    const fechaFinStr = this.formatoFecha(hoy);

    this.minFechaFinal = fechaInicioStr;

    this.formTanqueo.patchValue({
      fecha: fechaInicioStr,
      fechaFinal: fechaFinStr,
    });
  }

  toggle() {
    this.show = !this.show;
  }

async ExportaHV(
  placa: string,
  marca: string,
  modelo: string,
  nombre: string,
  tipos: string,
  color: string,
  matricula: string,
  fechalict: string,
  cilindraje: string,
  motor: string,
  serie: string,
  linea: string,
  organismo: string,
  Descripcion: string,
  capacidad: string,
  chasis: string,
  tanqueo: any[],
  imgFoto: string,
  imgUrl: string,
) {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "letter",
    compress: true,
  });

  // Header
  this.addHeader(doc, "FICHA DE COMBUSTIBLE");

     await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 170, y: 7, w: 35, h: 12 },
      logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
    },);


  // Bloque 1: Información del vehículo
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
   doc.setFillColor(230, 230, 230);
  doc.rect(5, 33, 205, 7, "F");
  doc.text("INFORMACIÓN DEL VEHÍCULO", 110, 38, { align: "center" });
  this.addVehiculoInfo(doc, placa, marca, modelo, 5, 41);
  this.addEmpresaInfo(doc, nombre, tipos, color, 110, 41);

  // Bloque 2: Licencia de tránsito
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setFillColor(240, 240, 240);
  doc.rect(5, 58, 205, 7, "F");
  doc.text("LICENCIA DE TRANSITO", 110, 63, { align: "center" });
  this.addVehiculosInfo(doc, matricula, fechalict, cilindraje, motor, serie, 5, 66);
  this.addVehiculos2Info(doc, linea, organismo, Descripcion, capacidad, chasis, 110, 66);

  // Bloque 3: Tabla de tanqueos
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setFillColor(240, 240, 240);
  doc.rect(5, 95, 205, 7, "FD");
  doc.text("TANQUEOS REALIZADOS", 110, 100, { align: "center" });
  this.addTablaTanqueos(doc, tanqueo, 5, 102.5);

  // Footer
  this.addFooter(doc, 1, 1);

  // Mostrar PDF
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
}


  addVehiculoInfo(
    doc: jsPDF,
    placa: string,
    marca: any,
    modelo: any,
    x: number,
    y: number
  ) {
    const data = [
      { label: "PLACA:", value: placa || "N/A" },
      { label: "MARCA:", value: marca?.toString() || "N/A" },
      { label: "MODELO:", value: modelo?.toString() || "N/A" },
    ];
    this.drawDataTable(doc, data, x, y);
  }

  addEmpresaInfo(
    doc: jsPDF,
    nombre: any,
    tipos: any,
    color: any,
    x: number,
    y: number
  ) {
    const data = [
      { label: "EMPRESA:", value: nombre?.toString() || "N/A" },
      { label: "CLASE:", value: tipos?.toString() || "N/A" },
      { label: "COLOR:", value: color?.toString() || "N/A" },
    ];
    this.drawDataTable(doc, data, x, y);
  }

  addVehiculosInfo(
    doc: jsPDF,
    matricula: any,
    fechalict: any,
    cilindraje: any,
    motor: any,
    serie: any,
    x: number,
    y: number
  ) {
    const data = [
      { label: "# MATRICULA:", value: matricula?.toString() || "N/A" },
      { label: "EXPEDICIÓN:", value: fechalict?.toString() || "N/A" },
      { label: "CILINDRAJE:", value: cilindraje?.toString() || "N/A" },
      { label: "# MOTOR:", value: motor?.toString() || "N/A" },
      { label: "# SERIE", value: serie?.toString() || "N/A" },
    ];
    this.drawDataTable(doc, data, x, y);
  }

  addVehiculos2Info(
    doc: jsPDF,
    linea: any,
    organismo: any,
    Descripcion: any,
    capacidad: any,
    chasis: any,
    x: number,
    y: number
  ) {
    const data = [
      { label: "LINEA:", value: linea?.toString() || "N/A" },
      { label: "ORGANISMO:", value: organismo?.toString() || "N/A" },
      { label: "SERVICIO:", value: Descripcion?.toString() || "N/A" },
      { label: "CAPACIDAD:", value: capacidad?.toString() || "N/A" },
      { label: "CHASIS:", value: chasis?.toString() || "N/A" },
    ];
    this.drawDataTable(doc, data, x, y);
  }

  drawDataTable(
    doc: jsPDF,
    data: { label: string; value: string }[],
    x: number,
    y: number
  ): number {
    const anchoLabel = 30;
    const anchoValue = 70;
    const anchoTotal = anchoLabel + anchoValue;
    const altoFila = 5;

    // Borde externo general
    const altoTotal = data.length * altoFila;
 
    doc.setDrawColor(200);
    doc.rect(x, y, anchoTotal, altoTotal); // marco exterior

    data.forEach((item, i) => {
      const filaY = y + i * altoFila;

      // Fondo gris claro solo para la celda de la etiqueta
      doc.setFillColor(230, 230, 230);
      doc.rect(x, filaY, anchoLabel, altoFila, "F"); // fondo de la etiqueta

      // Líneas internas horizontales
      if (i < data.length) {
        doc.line(x, filaY, x + anchoTotal, filaY); // línea superior de cada fila
      }

      // Línea vertical de separación (opcional, ya está con rects)
      doc.line(x + anchoLabel, filaY, x + anchoLabel, filaY + altoFila);

      // Texto: etiqueta (negrita) y valor
      doc.setFontSize(6).setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(String(item.label), x + 2, filaY + 3.5);
      //doc.setFont("helvetica", "bold");
      doc.text(String(item.value ?? "N/A"), x + anchoLabel + 2, filaY + 3.5);
    });

    return y + altoTotal;
  }

  addTablaTanqueos(doc: jsPDF, tanqueo: any[], x: number, y: number) {
    const tanqueosOrdenados = [...tanqueo].sort((a, b) => {
      return new Date(b.fecha).getTime() - new Date(a.fecha).getTime();
    });

    const columnas = [
      "ITEM",
      "FECHA",
      "KM",
      "COMBUSTIBLE",
      "GAL.",
      "VALOR",
      "TOTAL",
      "ESTACIÓN DE SERVICIO",
      "FACTURA",
      "FORMA",
    ];
    const anchosPorColumna = [8, 20, 16, 26, 12, 19, 20, 34, 23, 27];
    const altoFila = 6;
    let totalPagos = 0;
    let filaY = y;

    // 🔹 Encabezado
    let xActual = x;
    columnas.forEach((col, i) => {
      const ancho = anchosPorColumna[i];
       doc.setFillColor(230, 230, 230);
       doc.setDrawColor(200);
      doc.rect(xActual, filaY, ancho, altoFila, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(col);
      const textX = xActual + (ancho - textWidth) / 2;
      doc.text(col, textX, filaY + 4.5);
      xActual += ancho;
    });

    filaY += altoFila;

    // 🔹 Filas de datos
    for (let rowIndex = 0; rowIndex < tanqueosOrdenados.length; rowIndex++) {
      const m = tanqueosOrdenados[rowIndex];

      if (filaY > 260) {
        doc.addPage();
        this.addFooter(doc, 1, 1);
        filaY = 20;

        // Redibujar encabezado
        xActual = x;
        columnas.forEach((col, i) => {
          const ancho = anchosPorColumna[i];
          doc.setFillColor(200, 200, 200);
          doc.rect(xActual, filaY, ancho, altoFila, "F");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(7);
          doc.setTextColor(0, 0, 0);
           doc.setFillColor(230, 230, 230);
          doc.setDrawColor(200);
          const textWidth = doc.getTextWidth(col);
          const textX = xActual + (ancho - textWidth) / 2;
          doc.text(col, textX, filaY + 4.5);
          xActual += ancho;
        });

        filaY += altoFila;
      }

const valorNumber = Number(m.valor) || 0;
const totalNumber = Number(m.total) || 0;
totalPagos += totalNumber;

const facturaCell = m.factura ?? "N/A";

const fila = [
  rowIndex + 1,
  this.formatDate(m.fecha),
  m.km,
  m.combustible,
  m.galones,
  `$${valorNumber.toLocaleString("es-CO")}`,
  `$${totalNumber.toLocaleString("es-CO")}`,
  m.eds,
  facturaCell,
  m.forma,
];

let xFila = x;
fila.forEach((val, colIndex) => {
  const ancho = anchosPorColumna[colIndex];
  doc.setFont("helvetica", "normal");
  doc.setFontSize(5);
  doc.setTextColor(0, 0, 0);
  doc.setFillColor(230, 230, 230);
  doc.setDrawColor(200);

  // Dibujo de la celda
  doc.rect(xFila, filaY, ancho, altoFila);

  const text = String(val || "");
  const textWidth = doc.getTextWidth(text);
  const textX = xFila + (ancho - textWidth) / 2;
  const textY = filaY + 4.5;

  // 🔗 Si es la columna de Factura (colIndex === 8) y hay soporteUrl => link
  if (colIndex === 8 && m.soporteUrl) {
    doc.setTextColor(0, 0, 255); // azul tipo link
    doc.textWithLink(
      `Factura: ${m.factura} (Ver)`,
      textX-6,
      textY,
      { url: m.soporteUrl }
    );
    doc.setTextColor(0, 0, 0); // reset color
  } else {
    // Texto normal
    doc.text(text, textX, textY);
  }

  xFila += ancho;
});

      filaY += altoFila;
    }

    // 🔹 Fila TOTAL horizontal completa
    const anchoTotalFila = anchosPorColumna.reduce((a, b) => a + b, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.setFillColor(240, 240, 240);
    doc.rect(x, filaY, anchoTotalFila, altoFila, "F");

    // Texto: TOTAL a la izquierda
    doc.setTextColor(0, 0, 0);
    doc.text("TOTAL:", x + 2, filaY + 4.5);

    // Texto: valor total a la derecha
    const totalTexto = `$${totalPagos.toLocaleString("es-CO")}`;
    const totalTextWidth = doc.getTextWidth(totalTexto);
    const totalTextX = x + anchoTotalFila - totalTextWidth - 75;
    doc.text(totalTexto, totalTextX, filaY + 4.5);

    const observaciones = tanqueosOrdenados
      .map((tanqueo) => ({
        factura: String(tanqueo.factura ?? "Sin factura").trim(),
        texto: String(tanqueo.observacion ?? tanqueo.observaciones ?? "").trim(),
      }))
      .filter((item) => item.texto);

    if (observaciones.length > 0) {
      filaY += altoFila + 5;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("OBSERVACIONES", x, filaY);
      filaY += 5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      observaciones.forEach((item) => {
        const lineas = doc.splitTextToSize(
          `(${item.factura}) - ${item.texto}`,
          anchoTotalFila,
        );

        if (filaY + lineas.length * 4 > 270) {
          doc.addPage();
          this.addFooter(doc, 1, 1);
          filaY = 20;
        }

        doc.text(lineas, x, filaY);
        filaY += lineas.length * 4 + 2;
      });
    }
  }

  formatDate(fecha: any): string {
    if (!fecha) return "N/A";
    const d = new Date(fecha);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;
  }

   addHeader(doc: jsPDF,title:string) {
      const pageWidth = 216;       // Ancho total en mm (Letter)
      const marginLeft = 5;       // Margen izquierdo deseado
      const marginRight = 5;      // Margen derecho igual para simetría
      const rectY = 3;            // Distancia desde la parte superior
      const headerHeight = 20;     // Altura del encabezado
      const rectWidth = pageWidth - marginLeft - marginRight;
  
      // Dibujar el rectángulo del encabezado
      doc.setDrawColor(0, 0, 0);   // Borde negro
      doc.setLineWidth(0.5);       // Grosor del borde
      doc.rect(marginLeft, rectY, rectWidth, headerHeight);
  
      // Título centrado dentro del rectángulo
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
  
      const text = title;
      const centerX = marginLeft + rectWidth / 2;
      const textY = rectY + 12; // Ajuste vertical para ubicar el texto dentro del rectángulo
  
      doc.text(text, centerX, textY, { align: "center" });
    }
 async addHeaderImages(
     doc: jsPDF,
     gpcGoogle: any,
     imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>
   ) {
     const getSignedUrlSafe = async (path: string) => {
       try {
         const res = await gpcGoogle.getSignedUrl(path).toPromise();
         return res?.url || null;
       } catch {
         return null;
       }
     };
 
     const getImageBase64Safe = async (url: string | null) => {
       if (!url) return null;
       try {
         return await gpcGoogle.getImageBase64(url);
       } catch {
         return null;
       }
     };
 
     const imageKeys = Object.entries(imageMap);
     const signedUrls = await Promise.all(
       imageKeys.map(([_, img]) => getSignedUrlSafe(img.path))
     );
 
     const base64Images = await Promise.all(
       signedUrls.map((url) => getImageBase64Safe(url))
     );
 
     base64Images.forEach((base64, idx) => {
       const { x, y, w, h } = imageKeys[idx][1];
       if (base64) {
         doc.addImage(base64, "JPG", x, y, w, h, undefined, "FAST");
       } else {
         // Mostrar texto si no se pudo cargar la imagen
         doc.setFontSize(10);
         doc.setTextColor(100);
         doc.text("SIN SOPORTE CARGADO", x + 2, y + h / 2, { maxWidth: w });
       }
     });
   }

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const fechaHora = `${fecha} - ${hora}`;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100);

    doc.textWithLink(
      "Generado desde Admin SEAF – INDESOFT SAS",
      110,
      pageHeight - 12,
      {
         url: "https://indesoftsas.com",
        align: "center",
      }
    );

    doc.text(fechaHora, 10, pageHeight - 5);
    doc.text(`Página ${currentPage} de ${totalPages}`, 205, pageHeight - 5, {
      align: "right",
    });
  }

    private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        console.log(data);
          this.administraciones = data;       
              this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }

}